export default {
  videoPlayer: state => state.common.player,
}
